import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import { useContext, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'

interface Props {
  /**
   * 0-1
   *
   * @example 0.2 => 20%
   */
  discountPercentage?: number
}

function SearchTileWalledMessage({ discountPercentage }: Props) {
  const intl = useIntl()
  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  useEffect(() => {
    dispatchOfferListEvent({
      type: OfferListEvents.pricingCalculated,
      availability: true,
      price: undefined,
      roomRateId: undefined,
      memberPrice: undefined,
      duration: undefined,
    })
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <BodyTextBlock variant="medium" weight="bold" colour="light-foreground-alt" startIcon={<LineTagAltIcon />}>
    {/* TODO: i18n — contains pricing component (FormatPercent); verify rendered output after localisation */}
    {!!discountPercentage && <FormattedMessage
      id="smDNrmc8FdzV4K5PdNGC"
      defaultMessage="Get {discount} off with member prices"
      
      values={{ discount: <FormatPercent value={discountPercentage} /> }}
    />}
    {!discountPercentage && intl.formatMessage({
      id: 'aYpuMqNQsz7c-qd64KT9',
      defaultMessage: 'Sign up to access exclusive rates',
    })}
  </BodyTextBlock>
}

export default SearchTileWalledMessage
